/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's copyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

import React from 'react';
import { cn } from '@/shared/ui/utils/tailwind';

export type UnstyledButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  children: React.ReactNode;
  className?: string;
};

/**
 * UnstyledButton component with Tailwind styling
 * Replaces Mantine UnstyledButton
 */
export const UnstyledButton = React.forwardRef<HTMLButtonElement, UnstyledButtonProps>(
  ({ children, className, ...props }, ref) => {
    return (
      <button
        ref={ref}
        className={cn(
          "relative bg-transparent border-none p-0 cursor-pointer",
          "text-inherit font-inherit",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--seed-base)] focus-visible:ring-offset-2",
          "after:content-[''] after:absolute after:min-h-[44px] after:min-w-[44px] after:left-1/2 after:top-1/2 after:-translate-x-1/2 after:-translate-y-1/2",
          className
        )}
        {...props}
      >
        {children}
      </button>
    );
  }
);

UnstyledButton.displayName = 'UnstyledButton';

export default UnstyledButton;
